import type { ICurrencyMethodTableColumns } from '@entities/currency-method';
import { useCurrencyMethods } from '@entities/currency-method';
import ModalOpenBtn from '@features/modal-open-btn';
import ErrorMessage from '@shared/components/ErrorMessage';
import Loading from '@shared/components/Loading';
import LoadingSpinner from '@shared/components/LoadingSpinner';
import { Pagination, PaginationRows } from '@shared/components/Pagination';
import {
  Table,
  THead,
  TBody,
  TableActions,
  TableActionsItem,
  TableContainer,
  TableProvider,
} from '@shared/components/Table';

import { useTableSettings } from './settings/useTableSettings';

const SettingsCurrencyMethodsWidget = () => {
  const {
    currencyMethods,
    isLoading,
    isError,
    error,
    isFetching,
    refetch,

    filter,
  } = useCurrencyMethods();

  const { columnTitles, renderRow, NewCurrencyMethod } = useTableSettings({
    refetch,
  });

  if (isLoading) return <LoadingSpinner />;
  if (isError) return <ErrorMessage error={error} />;

  if (currencyMethods) {
    return (
      <>
        {isFetching && <Loading />}

        <TableProvider<ICurrencyMethodTableColumns> columnTitles={columnTitles} {...filter}>
          <TableActions>
            <TableActionsItem>
              <ModalOpenBtn text='New' modalContent={<NewCurrencyMethod />} size='sm' />
            </TableActionsItem>
          </TableActions>

          <TableContainer>
            <Table>
              <THead />
              <TBody items={currencyMethods.data} renderItem={renderRow} />
            </Table>
          </TableContainer>
          <div className='pagination-container'>
            <Pagination data={currencyMethods.meta} />
            <PaginationRows />
          </div>
        </TableProvider>
      </>
    );
  }

  return null;
};

export default SettingsCurrencyMethodsWidget;
